import React, { useContext, useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { useNavigate, useParams } from 'react-router-dom'
import { Image, Trash3, Eye, EyeSlash } from 'react-bootstrap-icons'
import axiosService from '../../../../../utils/AxiosService'
import { toastSuccess, toastError } from '../../../../FormComponents/Toasts'

export default observer(function ActionItem({ action }) {
  const { id, action_id } = useParams()
  const navigate = useNavigate()

  const displayUploadCount = () => {
    if (action.draft_uploads.length === 0) {
      return "Empty"
    } else if (action.draft_uploads.length === 1) {
      return `${action.draft_uploads.length} Upload`
    } else {
      return `${action.draft_uploads.length} Uploads`
    }
  }

  return (
    <div
      className={`${action_id && +action_id === +action.id ? 'border-2 border-rb-green dark:border-rb-green bg-rb-soft-green dark:bg-rb-green/20' : 'border-1 border-rb-widget-border dark:border-rb-dark-mode-lighter hover:cursor-pointer hover:shadow-md hover:transform hover:scale-102 transition-all duration-200'} cursor-pointer flex items-center p-2 w-full rounded-lg mb-2 bg-white dark:bg-rb-dark-mode`}
      onClick={() => {
        navigate(`/advertiser/campaign_share/${id}/draft_review/participants/${action.influencer_id}/actions/${action.id}`)
      }}
    >
      <div className='flex gap-2 items-center'>
        {
          action.draft_uploads.length > 0 ? (
            <img src={action.draft_uploads[0].videoThumb || action.draft_uploads[0].url} alt={action.username} className="h-12 w-12 rounded-lg" />
          ) : (
            <div className={`${action_id && +action_id === +action.id ? 'border-1 border-rb-green dark:border-rb-green bg-white dark:bg-rb-dark-mode' : 'bg-gray-100 dark:bg-rb-dark-mode-lighter'} h-12 w-12 flex items-center justify-center rounded-md`}>
              <Image className={`${action_id && +action_id === +action.id ? 'text-rb-green dark:text-rb-green' : 'text-gray-200 dark:text-gray-500'} text-2xl`} />
            </div>
          )
        }
        <div className='w-[170px]'>
          <div className="flex gap-2 items-center">
            <h4 className='text-md font-bold dark:text-white'>{action.name}</h4>
          </div>
          <span className={`text-sm font-semibold ${action_id && +action_id === +action.id ? 'text-rb-green dark:text-rb-green' : 'text-gray-300 dark:text-gray-400'}`}>
            { displayUploadCount() }
          </span>
        </div>
      </div>
    </div>
  )
})
